import { computed, onMounted, ref } from "vue";

// Delete when the CAT4-8832_UIRefreshMosaic is accepted.
const sidebarRef = ref<HTMLElement | null>(null);
const headerRef = ref<HTMLElement | null>(null);
const mainContentRef = ref<HTMLElement | null>(null);

export function useRootLayout() {
  const windowWidth = ref(window.innerWidth);

  const layout = computed(() => {
    if (windowWidth.value < 900) return "FIXED";
    return "FLEX";
  });

  onMounted(() => {
    window.addEventListener("resize", () => (windowWidth.value = window.innerWidth));
  });

  return { sidebarRef, headerRef, mainContentRef, layout };
}
